module.exports = __webpack_public_path__ + "img/main_cn.8ec453df.svg";